export default "__VITE_ASSET__COqG5BRJ__"